module.exports = __webpack_public_path__ + "static/media/api.36dd6a12.svg";